module.exports = __webpack_public_path__ + "img/chevron-down-solid.823319ac.svg";